module.exports = __webpack_public_path__ + "img/kirmizi-cizgi.0627565e.png";